"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
import { Icon } from "@/components/ui/Icon";
import { motion } from "motion/react";
import type { NavigationMessage } from "@/types/agent/message";
import { pushToDataLayer } from "@/lib/analytics/pushToDataLayer";
interface NavigateMessageProps {
  message: NavigationMessage;
}
export const NavigateMessage: React.FC<NavigateMessageProps> = t0 => {
  const $ = _c(39);
  const {
    message
  } = t0;
  const {
    duration,
    id,
    navigateTo,
    update,
    delete: deleteMessage,
    url
  } = message;
  const [isComplete, setIsComplete] = useState(message.isComplete);
  const [isAborted, setIsAborted] = useState(false);
  let t1;
  if ($[0] !== duration || $[1] !== isAborted || $[2] !== isComplete || $[3] !== navigateTo || $[4] !== update || $[5] !== url) {
    t1 = () => {
      if (isAborted || isComplete) {
        return;
      }
      const timer = setTimeout(() => {
        pushToDataLayer({
          event: "agent_link"
        });
        navigateTo?.(url);
        setIsComplete(true);
        update?.({
          isComplete: true
        } as Partial<NavigationMessage>);
      }, duration);
      return () => clearTimeout(timer);
    };
    $[0] = duration;
    $[1] = isAborted;
    $[2] = isComplete;
    $[3] = navigateTo;
    $[4] = update;
    $[5] = url;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== duration || $[8] !== id || $[9] !== isAborted || $[10] !== isComplete || $[11] !== navigateTo || $[12] !== update || $[13] !== url) {
    t2 = [duration, id, isAborted, navigateTo, update, url, isComplete];
    $[7] = duration;
    $[8] = id;
    $[9] = isAborted;
    $[10] = isComplete;
    $[11] = navigateTo;
    $[12] = update;
    $[13] = url;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  useEffect(t1, t2);
  let t3;
  if ($[15] !== deleteMessage || $[16] !== message) {
    t3 = () => {
      setIsAborted(true);
      message.abortNavigation?.(message.id);
      deleteMessage?.();
    };
    $[15] = deleteMessage;
    $[16] = message;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  const handleAbortNavigation = t3;
  let t4;
  if ($[18] !== deleteMessage || $[19] !== message) {
    t4 = () => {
      message.navigateTo?.(message.backUrl);
      deleteMessage?.();
    };
    $[18] = deleteMessage;
    $[19] = message;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  const handleNavigateBack = t4;
  const t5 = !isComplete ? handleAbortNavigation : handleNavigateBack;
  const t6 = !isComplete ? message.text : message.backText;
  const t7 = isComplete ? 1 : 0;
  let t8;
  if ($[21] !== t7) {
    t8 = {
      scaleX: t7
    };
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      scaleX: 1
    };
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  const t10 = isComplete ? 0 : duration / 1000;
  let t11;
  if ($[24] !== t10) {
    t11 = {
      duration: t10,
      ease: "linear"
    };
    $[24] = t10;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      transformOrigin: "left"
    };
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t11 || $[28] !== t8) {
    t13 = <motion.div className="w-full h-full left-0 top-0 absolute bg-yellow" initial={t8} animate={t9} transition={t11} style={t12} />;
    $[27] = t11;
    $[28] = t8;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== isComplete || $[31] !== message.backText || $[32] !== message.text) {
    t14 = <span className="relative z-10 text-center justify-center text-black text-base font-medium align-middle flex items-center gap-2">{!isComplete ? <>{message.text}<Icon name="agent-close" size={24} decorative={true} /></> : <>{message.backText}<Icon name="arrow-return" size={24} decorative={true} /></>}</span>;
    $[30] = isComplete;
    $[31] = message.backText;
    $[32] = message.text;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t13 || $[35] !== t14 || $[36] !== t5 || $[37] !== t6) {
    t15 = <button type="button" className="px-4 py-2 relative bg-white rounded-3xl inline-flex justify-start items-center gap-2.5 overflow-hidden outline-1 outline-white/20 cursor-pointer hover:outline-2 hover:outline-white/40 transition-colors" onClick={t5} aria-label={t6}>{t13}{t14}</button>;
    $[34] = t13;
    $[35] = t14;
    $[36] = t5;
    $[37] = t6;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  return t15;
};